import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  freightOverhead: false,
  dutyTariffOverhead: false,
  editMode: false,
  calculationTypeValue: null,
  isBanner: true,
}

const costComponentSlice = createSlice({
  name: 'costComponent',
  initialState,
  reducers: {
    setFreightOverhead: (state, action) => {
      state.freightOverhead = action.payload
    },
    setDutyTariffOverhead: (state, action) => {
      state.dutyTariffOverhead = action.payload
    },
    setEditMode: (state, action) => {
      state.editMode = action.payload
    },
    setCalculationTypeValue: (state, action) => {
      state.calculationTypeValue = action.payload
    },
    setIsBanner: (state, action) => {
      state.isBanner = false
    },
  },
})

export const {
  setFreightOverhead,
  setDutyTariffOverhead,
  setEditMode,
  setCalculationTypeValue,
  setIsBanner,
} = costComponentSlice.actions
export default costComponentSlice.reducer
